import { FC } from 'react';
import { SvgIcon } from 'src/components/atoms/SvgIcon';
import './styles.scss';

type Props = {
  color: string;
  className: string;
};

const SocialIcons: FC<Props> = ({ color, className }) => {
  return (
    <div className={`social-container ${className}`}>
      <div className="icon-container link" style={{ width: 25, height: 25, color }}>
        <a
          aria-label="facebook"
          href="https://www.facebook.com/TouRest.online/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <SvgIcon src="/images/icons/fbIcon.svg" />
        </a>
      </div>
      <div className="icon-container link" style={{ width: 25, height: 25, color }}>
        <a href="https://vk.com/tourest_online" target="_blank" rel="noopener noreferrer" aria-label="vkontakte">
          <img src="/images/icons/vk.svg" alt="vk-icon" />
        </a>
      </div>
      <div className="icon-container link" style={{ width: 25, height: 25, color }}>
        <a
          href="https://www.instagram.com/tourest_online/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="instagram"
        >
          <SvgIcon src="/images/icons/ig.svg" />
        </a>
      </div>
    </div>
  );
};

export default SocialIcons;
